import React from 'react'

const IconCross = () => {
  return (
    <svg width='8' height='8' viewBox='0 0 8 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.754063 7.72714L0.273438 7.24651L3.49927 3.99964L0.273438 0.773594L0.754063 0.292969L4.00094 3.5188L7.22698 0.292969L7.7076 0.773594L4.48177 3.99964L7.7076 7.24651L7.22698 7.72714L4.00094 4.5013L0.754063 7.72714Z'
        fill='#095BBD'
      />
    </svg>
  )
}

export default IconCross
